import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex align-items-center" }
const _hoisted_2 = { class: "font-bold text-sm text-right" }
const _hoisted_3 = { class: "ml-3 text-exm w-2rem text-right" }

import { toRefs } from 'vue';

export interface ChartLegendItemPropsInterface {
  className?: string;
  title: string;
  total?: string;
  color?: string;
  textColor?: string;
  numberColor?: string;
  percentage?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ChartLegendItem',
  props: {
    className: {},
    title: {},
    total: {},
    color: {},
    textColor: {},
    numberColor: {},
    percentage: {}
  },
  setup(__props: any) {

const props = __props;
const { className, title, total, color, textColor, numberColor, percentage } = toRefs(props);

const formatNumber = (value: number) => new Intl.NumberFormat().format(value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex justify-content-between py-1 pl-1 w-full", _unref(className)]),
    style: _normalizeStyle({ color: _unref(color) })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        style: _normalizeStyle({ background: _unref(color) }),
        class: "mr-2 dot"
      }, null, 4),
      _createElementVNode("div", {
        class: "text-xs",
        style: _normalizeStyle({ color: _unref(textColor) })
      }, _toDisplayString(_unref(title)), 5)
    ]),
    _createElementVNode("div", {
      class: "flex align-items-center",
      style: _normalizeStyle({ color: _unref(numberColor) })
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(formatNumber(_unref(total))), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(percentage)) + "%", 1)
    ], 4)
  ], 6))
}
}

})